export default "__VITE_ASSET__Bb$XdD4q__"